'use client';

import dynamic from 'next/dynamic';
import { FC } from 'react';

const GoogleOneTapClient = dynamic(() => import('./GoogleOneTapClient').then((mod) => mod.GoogleOneTapClient), {
  ssr: false,
});

export const GoogleOneTap: FC = () => <GoogleOneTapClient />;
